import { setAppBadge } from '../utils/desktopBridge';

export class FaviconBadge {
    private originalFavicon: string = "";
    private faviconSize: number = 64;
    private badgeColor: string = "#FF0000";
    private textColor: string = "#FFFFFF";

    constructor() {

        const faviconLink = document.querySelector("link[rel*='icon']") as HTMLLinkElement;
        if (faviconLink) {
            this.originalFavicon = faviconLink.href;
        }
    }

    update(unreadCount: number) {
        setAppBadge(unreadCount);

        if (unreadCount === 0) {
            // Restore original favicon
            this.setFavicon(this.originalFavicon);
            return;
        }

        const canvas = document.createElement('canvas');
        canvas.width = this.faviconSize;
        canvas.height = this.faviconSize;
        const ctx = canvas.getContext('2d');

        if (!ctx) return;

        const img = new Image();
        img.crossOrigin = 'anonymous';

        img.onload = () => {

            ctx.drawImage(img, 0, 0, this.faviconSize, this.faviconSize);

            this.drawBadge(ctx, unreadCount);

            this.setFavicon(canvas.toDataURL('image/png'));
        };

        img.onerror = () => {
            ctx.fillStyle = '#4A90E2';
            ctx.fillRect(0, 0, this.faviconSize, this.faviconSize);


            this.drawBadge(ctx, unreadCount);

            this.setFavicon(canvas.toDataURL('image/png'));
        };

        img.src = this.originalFavicon || '/favicon.ico';
    }

    private drawBadge(ctx: CanvasRenderingContext2D, unreadCount: number) {
        const badgeSize = this.faviconSize * 0.75; // Increased from 0.6 to 0.75
        const badgeX = this.faviconSize - badgeSize / 2;
        const badgeY = badgeSize / 2;


        ctx.shadowColor = 'rgba(0, 0, 0, 0.5)';
        ctx.shadowBlur = 4;
        ctx.shadowOffsetX = 1;
        ctx.shadowOffsetY = 1;

        ctx.fillStyle = this.badgeColor;
        ctx.beginPath();
        ctx.arc(badgeX, badgeY, badgeSize / 2, 0, 2 * Math.PI);
        ctx.fill();


        ctx.shadowColor = 'transparent';
        ctx.strokeStyle = this.textColor;
        ctx.stroke();


        ctx.fillStyle = this.textColor;
        ctx.font = `bold ${this.faviconSize * 0.5}px Arial`; // Increased font size
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';

        const displayCount = unreadCount > 99 ? '99+' : unreadCount.toString();
        ctx.fillText(displayCount, badgeX, badgeY);
    }

    private setFavicon(href: string) {
        let faviconLink = document.querySelector("link[rel*='icon']") as HTMLLinkElement;

        if (!faviconLink) {
            faviconLink = document.createElement('link');
            faviconLink.rel = 'icon';
            document.head.appendChild(faviconLink);
        }

        faviconLink.href = href;
    }

    clear() {
        this.update(0);
    }

}